import { FaTimes } from "react-icons/fa";

interface FormPopupProps {
  isOpen: boolean;
  onClose: (e: React.MouseEvent<HTMLElement>) => void;
}

const FormPopup: React.FC<FormPopupProps> = ({ isOpen, onClose, children }) => {
  return (
    <div className={`form-popup ${isOpen ? "active" : ""}`}>
      <div className="form-popup-center">
        <div className="form-popup-container">
          <a className="form-popup-close-btn" onClick={onClose}>
            <FaTimes size="20" />
          </a>
          {children}
        </div>
      </div>
      <div className="form-popup-bg" onClick={onClose}></div>
    </div>
  );
};
export default FormPopup;
